/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PatchedInfringementEvent
 */
export interface PatchedInfringementEvent {
    /**
     * 
     * @type {number}
     * @memberof PatchedInfringementEvent
     */
    readonly id?: number;
    /**
     * When this event occurred
     * @type {Date}
     * @memberof PatchedInfringementEvent
     */
    readonly eventDate?: Date;
    /**
     * Description of the progress or action taken
     * @type {string}
     * @memberof PatchedInfringementEvent
     */
    description?: string;
    /**
     * 
     * @type {Date}
     * @memberof PatchedInfringementEvent
     */
    readonly createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof PatchedInfringementEvent
     */
    readonly updatedAt?: Date;
}

/**
 * Check if a given object implements the PatchedInfringementEvent interface.
 */
export function instanceOfPatchedInfringementEvent(value: object): value is PatchedInfringementEvent {
    return true;
}

export function PatchedInfringementEventFromJSON(json: any): PatchedInfringementEvent {
    return PatchedInfringementEventFromJSONTyped(json, false);
}

export function PatchedInfringementEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchedInfringementEvent {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'eventDate': json['event_date'] == null ? undefined : (new Date(json['event_date'])),
        'description': json['description'] == null ? undefined : json['description'],
        'createdAt': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'updatedAt': json['updated_at'] == null ? undefined : (new Date(json['updated_at'])),
    };
}

  export function PatchedInfringementEventToJSON(json: any): PatchedInfringementEvent {
      return PatchedInfringementEventToJSONTyped(json, false);
  }

  export function PatchedInfringementEventToJSONTyped(value?: Omit<PatchedInfringementEvent, 'id'|'event_date'|'created_at'|'updated_at'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'description': value['description'],
    };
}

